import React, { useState, useEffect, useContext } from "react";
import { TranslatorContext } from "../../context/Translator";

import { useLocation , Link} from "react-router-dom"; // Importa useLocation

import PageLayout from "../../layouts/PageLayout";


import {commitPagosWebpay}  from "../../api/giras.ts";
import { Row, Col } from "react-bootstrap";
import { AnchorComponent } from "../../components/elements";

export default function MiPagoWebpayPage() {

    const { t, n } = useContext(TranslatorContext)
    const location = useLocation();
    const [pagos, setPagos] = useState([]);
    const [ordenCompra, setOrdenCompra] = useState(null);
    
   

    useEffect(() => {
        const params = new URLSearchParams(location.search); // Analiza los parámetros de la consulta
        let token = params.get('token_ws'); // Obtén el valor del parámetro 'gira'
        let orden = params.get('TBK_ORDEN_COMPRA'); // Obtén el valor del parámetro 'gira'
       if(token === null){
         token = params.get('TBK_TOKEN'); // Obtén el valor del parámetro 'gira'
       }

       if(orden !== null){
        setOrdenCompra(orden);
      }
        const fetchTabla = async () => {
            const res = await commitPagosWebpay(token);
            console.log(res);
            setPagos(res);
        }

        fetchTabla();
               
     }, []);

    return (
        <PageLayout>
            <Row >
                <Col xl={12}>
                                    <div className="mc-card">
                                        <div className='mc-breadcrumb'>
                                            <h3 className="mc-breadcrumb-title">Gira de Estudio</h3>
                                            <ul className="mc-breadcrumb-list">
                                            <li className="mc-breadcrumb-item"><Link to='#' className="mc-breadcrumb-link">{t('home')}</Link></li>
                                                
                                                <li className="mc-breadcrumb-item">Pagos</li>
                                            </ul>
                                        </div>
                                    </div>
                </Col>
                <Col xl={12} style={{ height: "650px" }}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                    {pagos && pagos.error === true ? (
                                <div className="error-message mejorada">
                                <i className="material-icons" style={{ color: "#e53935", verticalAlign: "middle", marginRight: 8,  fontSize: "3.2rem" }}>error_outline</i>
                                <h2>Orden de Compra {pagos.orden || ordenCompra} rechazada</h2>
                                <p>Las posibles causas de este rechazo son:</p>
                                <ul>
                                    <li>Error en el ingreso de los datos de su tarjeta de crédito o débito (fecha y/o código de seguridad).</li>
                                    <li>Su tarjeta de crédito o débito no cuenta con saldo suficiente.</li>
                                    <li>Tarjeta aún no habilitada en el sistema financiero.</li>
                                </ul>
                                </div>
                    ) : pagos && pagos.error === false ? (
                        <div className="success-message mejorada">
                            <i
                                className="material-icons"
                                style={{
                                    color: "#43a047",
                                    verticalAlign: "middle",
                                    marginRight: 10,
                                    fontSize: "3.2rem"
                                }}
                            >
                                check_circle
                            </i>
                        <h2>¡Pago realizado con éxito!</h2>
                        <p>Gracias por su pago. Su transacción ha sido procesada correctamente.</p>
                        <ul>
                            <li>Número de orden de pedido: {pagos.orden}</li>
                            <li>Nombre del comercio.: Estugira.com</li>
                            <li>Monto y moneda de la transacción: $ {pagos.data.amount}</li>
                            <li>Código de autorización de la transacción: {pagos.data.authorization_code}</li>
                            <li>Fecha de la transacción:  {pagos.data.transaction_date}</li>
                            <li>Tipo de pago realizado (Débito o Crédito): {pagos.data.payment_type_code}</li>
                            <li>Cantidad de cuotas: {pagos.data.installments_number}</li>
                            <li>Cuatro últimos dígitos de la tarjeta bancaria:  {pagos.data.card_detail.card_number}</li>
                            <li>Descripción de los bienes y/o servicios: Pago de cuotas de gira de estudio</li>
                        </ul>
                        <p>Hemos enviando un email con el detalle de su pago.</p>
                        <p>
                        
                            <AnchorComponent to={{
                                                                                                    pathname: "/ver-mi-gira",
                                                                                                    search: "?gira="+pagos.gira.gir_id+"&alumno="+pagos.alumno.alumno.alu_id,
                                                                                                }} title="View" className="btn btn-primary">Volver a la Gira</AnchorComponent>
                        </p>
                        </div>
                        
                    ) : (
                        <div className="loading-message">
                        <p>Cargando información del pago...</p>
                        </div>
                    )}
                        </div>
                    </div>
                    
                </Col>
            </Row>
            
        </PageLayout>
    );
}
